import React from "react"
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { IoWarningOutline } from "react-icons/io5";
import { DescriptionText, IconBackground, ModalButtonsContainer, PaymentModal, TitleText } from "../../PaymentComponents";
import { StyledModalBody } from "../../../../components/Modals";
import { Flex } from "../../../../components/ui/Flex";
import { ButtonBodyVariant } from "../../../../components/ui/ButtonVariant";
import { closeActiveModal } from "../../../../helper/modals";
import { Palette } from "../../../../components/utils";
import { cancelScheduledTransfer } from "../../../../redux/actions/payments";
import { dispatchPaymentsPageRefetch } from "../../PaymentUtils";
import { setToast } from "../../../../redux/actions/window";

const CancelInvoiceConfirmation = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation();
  const { modal, data } = useSelector((state) => state.headerModal);
  const cancelInvoice = () => {
    dispatch(cancelScheduledTransfer({
      body: {
        ScheduledTransferID: String(data.vopay_scheduled_transfers_id ?? ''),
        BuildingID: Number(data.building_id),
      },
      success: () => {
        closeActiveModal()

        dispatch(
          setToast({
            toastShow: true,
            toastMessage: t('Scheduled payment has been successfully cancelled')
          })
        );

        dispatchPaymentsPageRefetch();
      },
      fail: (err) => {
        dispatch(
          setToast({
            toastShow: true,
            toastMessage: t('Could not cancel transaction: {{error}}', { error: err?.data?.message }),
            modal: 'errorToast'
          })
        );
      }
    }))
  }

  return (
    <PaymentModal
      show={modal === 'CancelInvoiceConfirmation'}
      onClose={closeActiveModal}
      closeOnBackdrop={false}
      width={'460px'}
      padding={"2.25rem 1.5rem 3rem 1.5rem"}
    >
      <StyledModalBody>
        <Flex direction="column" alignItems="center" gap="1.5rem">
          <IconBackground background={Palette.RUSTY_ORANGE}>
            <IoWarningOutline size={32} color={Palette.WHITE} style={{ position: "absolute", right: "12px", top: "11px" }} />
          </IconBackground>
          <Flex direction="column" alignItems="center" gap="1rem">

            <TitleText lg>{t('Confirmation')}</TitleText>
            <DescriptionText>
              Are you sure you want to cancel this recurring payment?
              <br />
            </DescriptionText>

          </Flex>
          <ModalButtonsContainer gapY="8px" column>
            <ButtonBodyVariant onClick={cancelInvoice} cssOverride={"width: 100%;"}>{t('Cancel Recurring Payment')}</ButtonBodyVariant>
            <ButtonBodyVariant variant="secondary" onClick={closeActiveModal} cssOverride={"width: 100%;"}>{t('Cancel')}</ButtonBodyVariant>
          </ModalButtonsContainer>
        </Flex>
      </StyledModalBody>
    </PaymentModal >
  )
}

export default CancelInvoiceConfirmation